<div class="add" *ngIf="!readonly" (click)="onAddClick()">
  <mat-icon matTooltip="{{ 'MENU.BARCODES.ADD' | translate }}">add</mat-icon>
</div>

<div class="table-container" *ngIf="rows.length > 0">
  <table mat-table [dataSource]="rows">

    <ng-container matColumnDef="barcode">
      <th mat-header-cell *matHeaderCellDef>{{ 'MENU.BARCODES.BARCODE' | translate }}</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <input type="text"
               maxlength="20"
               [disabled]="readonly"
               [class.isDifferent]="!isIikoRow(row)"
               [class.isInvalid]="!readonly && isBarcodeInvalid(row)"
               matTooltip="{{ getContainerName(row) }}"
               value="{{row.barcode}}"
               (change)="onBarcodeChange(i, $event.target.value)">
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>{{ 'MENU.BARCODES.AMOUNT' | translate }}</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <input type="number"
               min="0"
               max="999.999"
               step="0.001"
               [disabled]="readonly"
               [class.isDifferent]="!isIikoRow(row)"
               [class.isInvalid]="!readonly && isAmountInvalid(row)"
               value="{{row.amount}}"
               (change)="onAmountChange(i, $event.target.value)">
      </td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>{{ 'MENU.BARCODES.SOURCE' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="isIikoRow(row)" class="iiko-source">{{ 'MENU.BARCODES.SOURCE_IIKO' | translate }}</span>
        <span *ngIf="!isIikoRow(row)" class="manual-source">{{ 'MENU.BARCODES.SOURCE_MANUAL' | translate }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row; let i = index">
        <mat-icon *ngIf="!readonly && isChangedIikoRow(row)"
                  mat-icon-button
                  aria-label="Clear"
                  class="restore"
                  (click)="restoreRow(i)"
                  matTooltip="{{ getIikoAmount(row) }}">restore</mat-icon>
        <mat-icon *ngIf="!readonly"
                  class="clear"
                  (click)="onDeleteClick(i)"
                  matTooltip="{{ 'COMMON.DELETE' | translate }}">clear</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
  </table>
</div>

<div class="missing" *ngIf="missingIikoBarcodes.length > 0">
  <div class="missing-title">{{ 'MENU.BARCODES.MISSING_FROM_IIKO' | translate }}</div>
  <div class="missing-item" *ngFor="let barcode of missingIikoBarcodes">
    <span matTooltip="{{ barcode.containerName }}">{{ barcode.barcode }} — {{ barcode.amount }}</span>
    <mat-icon *ngIf="!readonly" class="missing-add" (click)="addMissing(barcode)"
              matTooltip="{{ 'COMMON.ADD' | translate }}">add_circle_outline</mat-icon>
  </div>
</div>

<div class="error" *ngFor="let error of validationErrors">{{ error.key | translate: error.params }}</div>

<div class="restore-button" *ngIf="canRestore()" (click)="restore()">
  <mat-icon>restore</mat-icon>
  <span>{{ 'MENU.BARCODES.RESET_TO_IIKO' | translate }}</span>
</div>
